export const firebaseAPIKey = process.env.REACT_APP_FIREBASE_API_KEY;
export const resourceAPIURL = process.env.REACT_APP_RESOURCE_API_URL;

export const sentryDSN = process.env.REACT_APP_SENTRY_DSN;

export const gtWidgetURL = process.env.REACT_APP_GT_WIDGET_URL || "https://wa-wilma-partdiagrams-p-uks.azurewebsites.net";
